import React from 'react'
import { ChartLegendProps } from './ChartLegend.types'
import styles from './ChartLegend.module.scss'
import cl from 'classnames'
import { ImageSquare, Text1 } from 'components/shared'
import { ColorCircle } from '../ColorCircle'

const ChartLegendComponent = (props: ChartLegendProps) => {
  const {
    className,
    style,
    elements
  } = props

  return (
    <div
      className={cl(styles.container, className)}
      style={style}
    >
      {elements.map((element, index) => (
        <div
          key={index}
          className={styles.element}
        >
          <ColorCircle color={element.color} />

          {element.image && (
            <ImageSquare
              src={element.image}
              width={30}
              showBorder
              style={{
                marginLeft: 10,
                marginRight: 2
              }}
            />
          )}

          <Text1
            overflowEllipsis
            style={{ maxWidth: 150 }}
            title={element.label}
          >
            {element.label}
          </Text1>
        </div>
      ))}
    </div>
  )
}

const ChartLegend = ChartLegendComponent
export { ChartLegend }
